import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseDtoService } from './base-dto.service';
import { LeadClient, LeadDto } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class LeadService extends BaseDtoService {
    constructor(private readonly client: LeadClient) {
        super();
    }

    async getAll(): Promise<LeadDto[]> {
        return await lastValueFrom(this.client.leadGetAll());
    }

    async getById(id: number): Promise<LeadDto> {
        return await lastValueFrom(this.client.leadGetById(id));
    }

    async getByIds(ids: number[]): Promise<LeadDto[]> {
        return await lastValueFrom(this.client.leadGetByIds(ids));
    }
}
